
const ENFishBoneChart = {
	"Erro ao adicionar causa":"Error on add cause",
	"Erro ao alterar causa":"Error on edit cause",
	"Adicionar causa":"Add cause",
	"Alterar causa":"Change cause",
	"Máquina":"Machine",
	"Mão Obra":"Labor",
	"Material":"Material",
	"Meio Ambiente":"Environment",
	"Método":"Method",
	"Medidas":"Measures",
	"Exclusão da causa":"Delete cause",
	"Erro ao excluir causa":"Error on delete cause",
	"Deseja realmente excluir a causa":"Do you really want to delete the cause"
};

export default ENFishBoneChart;
